/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Link } from 'carbon-components-react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { getCreateInstanceUrl } from '../../util/console';

import './NoInstances.scss';

const messages = defineMessages({
  title: {
    id: 'modules.ia.components.Instances.NoInstances.title',
    defaultMessage: 'No instances found'
  },
  //NOTE we're intentionally using 'watsonx' here even though this will
  // be presented also by Classic -- motivation is that Classic displays first on login
  description: {
    id: 'modules.ia.components.Instances.NoInstances.description',
    defaultMessage:
      "No IBM watsonx Assistant instances were found that can be accessed by your IBM ID <i>{bluemixid}</i>. If you were invited to another person's IBM Cloud account, ask that person for help finding the account. Otherwise, you can create your own watsonx Assistant instance directly through IBM Cloud."
  },
  docLink: {
    id: 'modules.ia.components.Instances.NoInstances.docLink',
    defaultMessage:
      'Need help getting started? Consult our <a target="_blank" rel="noopener noreferrer" href="http://www.ibm.com/watson/developercloud/doc/conversation/index.shtml">documentation</a>.'
  },
  createInstanceLink: {
    id: 'modules.ia.components.Instances.NoInstances.createInstanceLink',
    defaultMessage: 'Go to IBM Cloud to create a watsonx Assistant instance.'
  }
});

const parseItalicWords = (chunks: string) => <i>{chunks}</i>;

const NoInstances: React.FC<{ username: string }> = ({ username }) => {
  const createInstanceUrl = getCreateInstanceUrl();

  return (
    <div className="NoInstances">
      <FormattedMessage tagName="h2" {...messages.title} />
      <FormattedMessage
        tagName="p"
        {...messages.description}
        values={{ i: parseItalicWords, bluemixid: username }}
      />
      <Link
        className="NoInstances__create-instance-link"
        href={createInstanceUrl}>
        <FormattedMessage tagName="p" {...messages.createInstanceLink} />
      </Link>
    </div>
  );
};

export default NoInstances;
